/**
 * @file product-faq.js
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakProductFaq = {
    attach: function (context, settings) {
      $(".faq-wrapper").each(function () {
        const accordionTitle = $(this).find(".accordion-title");
        $(once('faq', accordionTitle, context)).on("click", function () {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).next(".accordion-content").slideUp();
          } else {
            $(this).addClass("active");
            $(this).next(".accordion-content").slideDown();
          }
        });
      });
    },
  };
})(jQuery, Drupal, once);
